export default {
  title: 'Ссылки',

  short: {
    title: 'Короткие ссылки'
  },

  domains: {
    title: 'Домены'
  },

  presets: {
    title: 'Пресеты'
  },

  tracking: {
    title: 'Переходы'
  }
}
